
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    url: {
      type: String,
      default: 'newsdetail'
    }
  }
}
